import { PRODUCT_NAME } from '../components/constants'

type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  loaded?: boolean
  queue?: unknown[][]
  version?: string
}

declare global {
  interface Window {
    _fbq?: MetaPixelFunction
    fbq?: MetaPixelFunction
  }
}

const META_PIXEL_ID = '1283713107151286'
let pageViewTracked = false

export function initializeMetaPixel() {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
        return
      }

      fbq.queue?.push(args)
    }) as MetaPixelFunction

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    window.fbq('init', META_PIXEL_ID)
  }

  if (!pageViewTracked) {
    window.fbq('track', 'PageView')
    pageViewTracked = true
  }
}

export function trackAddToCart() {
  if (typeof window === 'undefined' || !window.fbq) return

  window.fbq('track', 'AddToCart', {
    content_name: PRODUCT_NAME,
    content_type: 'product',
    currency: 'UYU',
    value: 599,
  })
}
